/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import $ from "jquery";
import LeftMenu from "./LeftMenu";
import Profile from "./Profile";

class NavbarLeft extends React.Component {
    static propTypes = {
        miniNavbar: PropTypes.bool,
        leftMenu: PropTypes.array.isRequired,
        /**
         * @property {Person}
         */
        person: PropTypes.object.isRequired,
        /**
         * @property {PersonRole}
         */
        activeRole: PropTypes.object.isRequired,
        onClickSwitchRole: PropTypes.func,
        onClickProfile: PropTypes.func,
        onClickLogout: PropTypes.func
    };

    static defaultProps = {
        miniNavbar: false
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.toggleNavbar(this.props.miniNavbar);
    }

    componentWillReceiveProps(nextProps) {
        this.toggleNavbar(nextProps.miniNavbar);
    }

    toggleNavbar(miniNavbar) {
        $("body").toggleClass("mini-navbar", miniNavbar);
        this.SmoothlyMenu();
    }

    SmoothlyMenu() {
        if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
            // Hide menu in order to smoothly turn on when maximize menu
            $('#side-menu').hide();
            // For smoothly turn on menu
            setTimeout(
                function () {
                    $('#side-menu').fadeIn(400);
                }, 200);
        } else if ($('body').hasClass('fixed-sidebar')) {
            $('#side-menu').hide();
            setTimeout(
                function () {
                    $('#side-menu').fadeIn(400);
                }, 100);
        } else {
            // Remove all inline style from jquery fadeIn function to reset menu state
            $('#side-menu').removeAttr('style');
        }
    }

    // <span><img alt="image" className="img-circle" src="/img/profile_small.jpg"/></span>
    render() {
        return (
            <nav className="navbar-default navbar-static-side">
                <div className="sidebar-collapse">
                    <Profile
                        person={this.props.person}
                        activeRole={this.props.activeRole}
                        onClickSwitchRole={this.props.onClickSwitchRole}
                        onClickProfile={this.props.onClickProfile}
                        onClickLogout={this.props.onClickLogout}
                    />
                    <LeftMenu menu={this.props.leftMenu}/>
                </div>
            </nav>
        );
    }
}

export default NavbarLeft;
